import { render, staticRenderFns } from "./modalProcedimentosVinculadosIncluir.vue?vue&type=template&id=4bc3a176&scoped=true"
import script from "./modalProcedimentosVinculadosIncluir.vue?vue&type=script&lang=ts"
export * from "./modalProcedimentosVinculadosIncluir.vue?vue&type=script&lang=ts"
import style0 from "./modalProcedimentosVinculadosIncluir.vue?vue&type=style&index=0&id=4bc3a176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc3a176",
  null
  
)

export default component.exports